import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { EMAIL_DOES_NOT_EXIST_MSG, ENTER_VALID_EMAIL_ADDRESS, ENTER_YOUR_EMAIL_ADDRESS } from 'src/app/constant/responseMessage';
import { UserService } from 'src/app/services/user.service';
import { copyRight, LOGIN_TEXT } from 'src/app/constant/constant';
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  formValue:FormGroup
  email:any;

  loading:boolean = false
  errorMsg: any;

  copyRight: string = copyRight;
  appVersion: string = '';

  forgotPasswordError: string = '';

  loginText: string = LOGIN_TEXT;

  constructor(
    private api:UserService,
    private router:Router,private toastr:ToastrService,
    private configurationService: ConfigurationService) {
    this.formValue = new FormGroup({
      email:new FormControl('', [Validators.required, Validators.email])
    })
  }

  ngOnInit(): void {
    this.configurationService.appVersion$.subscribe(version => this.appVersion = version);
  }

  OnInputChange(): void {
    this.forgotPasswordError = '';
  }

  resetPassword(){
    this.email = this.formValue.controls['email'].value
    this.loading = true
  }

  validateEmail(): boolean {
    if(this.formValue.invalid){
      if(this.formValue.controls['email'].hasError('required')){
        this.forgotPasswordError = ENTER_YOUR_EMAIL_ADDRESS;
        return false;
      }else if(this.formValue.controls['email'].hasError('email')){
        this.forgotPasswordError = ENTER_VALID_EMAIL_ADDRESS;
        return false;
      }
    }
    return true;
  }

  resendPassword(){
    if(!this.validateEmail()){
      return;
    }
    this.email = this.formValue.controls['email'].value;
    this.loading = true
    this.api.resendPassword(this.email).subscribe({next:(res) => {
      if(res.status != 0){
        this.toastr.error(res.message)
      }else{
        this.toastr.success(res.message)
        this.router.navigate([''])
      }
      this.loading = false
      }, error: err=>{
        if(err.status === 401){
          this.forgotPasswordError = EMAIL_DOES_NOT_EXIST_MSG;
          this.loading = false;
        }else{ 
          this.loading = false;
        }
      }})
    }
    onCancelClicked(){
    this.router.navigate([''])
  }
}
